const state = {
  documentos: [],
  documentos2: [],
  documentosASolicitar: [],
  imagenComprobante: null,
  gifsDocs: [
    {
      idDocumento: 1,
      ruta: './gifs/001 -- INE FRONTAL.gif',
    },
    {
      idDocumento: 2,
      ruta: './gifs/002 -- INE REVERSO.gif',
    },
    {
      idDocumento: 3,
      ruta: './gifs/003 --SELFIE CON INE.gif',
    },
    {
      idDocumento: 4,
      ruta: './gifs/004 --COMPROBANTE DE DOMICILIO.gif',
    },
    {
      idDocumento: 5,
      ruta: './gifs/005 --COMPROBANTES FISCALES DE NOMINA.gif',
    },
    {
      idDocumento: 6,
      ruta: './gifs/005 --COMPROBANTES FISCALES DE NOMINA.gif',
    },
  ],
  totalDocumentos: null,
  contadorDocumentos: 0,
}

const mutations = {
  setDocumentos(state, payload) {
    state.totalDocumentos = payload.length
    state.contadorDocumentos = 0
    state.documentos2 = []
    state.documentos = []

    payload.forEach((doc) => {
      state.documentos.push({
        archivoBase64: '',
        idDocumento: doc.id_documento,
        TituloDocumento: doc.nombreDocumento,
      })
    })
  },
  insertDocumentos(state, payload) {
    const docIndex = state.documentos.findIndex(
      (obj) => obj.idDocumento == payload.id
    )

    const doc = {
      archivoBase64: payload.imagenBase64,
      idDocumento: state.documentos[docIndex].idDocumento,
      TituloDocumento: state.documentos[docIndex].TituloDocumento,
    }

    const doc2 = {
      archivo: payload.imagenBase64.split(',')[1],
      id_documento: state.documentos[docIndex].idDocumento,
      folio: payload.folioDigital,
    }

    state.documentos[docIndex] = doc
    state.documentos2 = doc2
  },
  insertDocumentosASolicitar(state, payload) {
    state.documentosASolicitar = []
    const docs = payload.split(',')

    docs.forEach((doc) => {
      state.documentosASolicitar.push({
        texto: doc,
        icono: 'mdi-checkbox-blank-circle',
      })
    })
  },
  insertComprobante(state, payload) {
    state.imagenComprobante = payload
  },
  restablecerDocumentos(state) {
    state.contadorDocumentos = 0
    state.documentos2 = []
    state.documentos = state.documentos.map((documento) => {
      return {
        archivoBase64: '',
        idDocumento: documento.idDocumento,
        TituloDocumento: documento.TituloDocumento,
      }
    })
  },
  setTotalDocumentos(state, payload) {
    state.totalDocumentos = payload
  },
  siguienteDocumento(state) {
    if (
      state.contadorDocumentos > state.totalDocumentos - 2 &&
      state.documentos[state.contadorDocumentos].archivoBase64 != ''
    ) {
      state.contadorDocumentos = -1
    } else if (state.documentos[state.contadorDocumentos].archivoBase64 != '') {
      state.contadorDocumentos++
    }
  },
  omitirDocumento(state) {
    if (state.contadorDocumentos >= state.totalDocumentos - 1) {
      state.contadorDocumentos = -1
    } else {
      state.contadorDocumentos++
    }
  },
}

const actions = {
  establecerDocumentos(context, payload) {
    context.commit('setDocumentos', payload)
  },
  insertarDocumentos(context, payload) {
    context.commit('insertDocumentos', payload)
  },
  insertarDocumentosASolicitar(context, payload) {
    context.commit('insertDocumentosASolicitar', payload)
  },
  insertarComprobante(context, payload) {
    context.commit('insertComprobante', payload)
  },
  restablecerDocumentos(context) {
    context.commit('restablecerDocumentos')
  },
  establecerTotalDocumentos(context, payload) {
    context.commit('setTotalDocumentos', payload)
  },
  siguienteDocumento(context) {
    context.commit('siguienteDocumento')
  },
  omitirDocumento(context) {
    context.commit('omitirDocumento')
  },
}

const getters = {
  obtenerImagenBase64: (state) => (id) => {
    return state.documentos.find((doc) => doc.idDocumento === id).archivoBase64
  },
  obtenerDocumentos(state) {
    return state.documentos
  },
  obtenerDocumentosASolicitar(state) {
    return state.documentosASolicitar
  },
  obtenerDocumentosSolicitudDigital(state) {
    return state.documentos2
  },
  obtenerComprobanteBase64(state) {
    return state.imagenComprobante
  },
  obtenerGifsDocumentos: (state) => (id) => {
    return state.gifsDocs.find((doc) => doc.idDocumento === id).ruta
  },
  obtenerSiguienteDocumento: (state) => {
    return state.contadorDocumentos
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
